<template>
    <div :class="'async-'+component +' async-component'">
      <component ref="asyncComponent" :is="remote" v-if="remote && !hasError" :test="test" @handler="haha" />
      <div v-if="hasError" class="error-fallback">
        <p>Failed to load remote component: {{ component }}</p>
      </div>
    </div>
  </template>

  <script>
  import Vue from 'vue'
  import $ from 'jquery'
  import {
    loadModule
  } from 'vue3-sfc-loader/dist/vue2-sfc-loader.js'

  export default {
    name: 'RemoteComponent',
    inheritAttrs: false,
    props: {
        // 远程vue文件名称
        component: {
        type: String,
        default: ''
      }
    },
    data() {
      return {
        remote: null,
        test: "123",
        hasError: false
      }
    },
    mounted() {
      this.load()
    },
    methods: {
      haha(data) {
        // alert(data)
      },
      child() {
        this.$refs.asyncComponent.handler("")
      },
      // 加载
      async load() {
        try {
          let url = "";

          if (window.location.href.includes("www.kia.cn")) {
            url = "https://" + "www.kia.cn/" + `${this.component}.vue`
          }else{
            url = "https://" + "uat.kia.cn/" + `/${this.component}.vue`
          }

          const com = await loadModule(url, {
            moduleCache: {
              vue: Vue,
              // jquery:require('jquery'),
              jquery:$,
            },
            // 获取文件
            async getFile(url) {
              try {
                const url2 = url.replace('.vue', '.html');

                const res = await fetch(url2)
                if (!res.ok) {
                  throw Object.assign(new Error(`${res.statusText} ${url2}`), {
                    res
                  })
                }
                return {
                  getContentData: asBinary => (asBinary ? res.arrayBuffer() : res.text()),
                }
              } catch (error) {
                console.error('Error in getFile:', error);
                throw error;
              }
            },
            // 添加样式
            addStyle(textContent) {
              try {
                const style = Object.assign(document.createElement('style'), {
                  textContent
                })
                const ref = document.head.getElementsByTagName('style')[0] || null
                document.head.insertBefore(style, ref)
              } catch (error) {
                console.error('Error in addStyle:', error);
              }
            },
          })
          this.remote = com
        } catch (error) {
          console.error('Error loading remote component:', error);
          // Set remote to null to prevent rendering errors
          this.remote = null;
          this.hasError = true;
        }
      },
    },
  }
  </script>
  <style>
  .async-component {
    width: 100%;
  }
  .error-fallback {
    padding: 20px;
    background-color: #f5f5f5;
    border: 1px solid #ddd;
    border-radius: 4px;
    text-align: center;
    color: #666;
  }
  </style>
